import { makeStyles } from '@material-ui/core/styles';

// Inspired by the former Facebook spinners.
const useStylesFacebook = makeStyles((theme) => ({
    bottom: {
        width: '100%',
        height: '100%',
        alignContent: 'center'
    },
}));

export default useStylesFacebook